import axios from "axios";

export const API = "/api";

export function getCsrfToken() {
  const cookies = document.cookie.split("; ");

  const secureCookie = cookies.find((item) =>
    item.trim().startsWith("__Host-edujac_csrf=")
  );
  const developmentCookie = cookies.find((item) =>
    item.trim().startsWith("edujac_csrf=")
  );

  const cookie = secureCookie || developmentCookie;

  return cookie
    ? decodeURIComponent(cookie.split("=").slice(1).join("="))
    : "";
}

const api = axios.create({
  baseURL: API,
  timeout: 30000,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();

  if (!["get", "head", "options"].includes(method)) {
    const csrf = getCsrfToken();

    if (csrf) {
      config.headers["X-CSRF-Token"] = csrf;
    }
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = String(error?.config?.url || "");

    const isAuthenticationRequest =
      requestUrl.includes("/auth/login") ||
      requestUrl.includes("/auth/forgot-password") ||
      requestUrl.includes("/auth/reset-password");

    if (status === 401 && !isAuthenticationRequest) {
      window.dispatchEvent(
        new CustomEvent("edujac:session-expired")
      );
    }

    return Promise.reject(error);
  }
);

export default api;

export async function openFile(path) {
  const { data } = await api.get("/files/sign", {
    params: { path },
  });

  const downloadUrl =
    `${API}/files/download` +
    `?path=${encodeURIComponent(path)}` +
    `&dt=${encodeURIComponent(data.token)}`;

  window.open(
    downloadUrl,
    "_blank",
    "noopener,noreferrer"
  );
}

export function formatErr(
  error,
  fallback = "Something went wrong. Please try again."
) {
  const detail = error?.response?.data?.detail;

  if (typeof detail === "string") {
    return detail;
  }

  if (Array.isArray(detail)) {
    return detail
      .map((item) => item?.msg)
      .filter(Boolean)
      .join(" ");
  }

  return fallback;
}

export const inr = (value) =>
  "₹" + Number(value || 0).toLocaleString("en-IN");

export const fmtDate = (iso) => {
  if (!iso) return "";

  const date = new Date(iso);

  return date.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

// School-day dates are anchored to IST (Asia/Kolkata)
// so frontend dates match backend today_str().
const IST_FMT = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Asia/Kolkata",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export const todayLocal = () =>
  IST_FMT.format(new Date());

export const daysAgoLocal = (numberOfDays) => {
  const date = new Date(
    todayLocal() + "T00:00:00Z"
  );

  date.setUTCDate(
    date.getUTCDate() - numberOfDays
  );

  return date.toISOString().slice(0, 10);
};